import ScrollReveal from "scrollreveal";
import anime from 'animejs/lib/anime.es.js';

const landingPageIntro = function () {
		
	const srOptions = {
		duration: 1000,
		distance: "50px",
		opacity: 0
	};
	
	var slideUp = {
		duration: 1000,
		opacity: 0.2,
		afterReveal: homepageIntro,
		easing: 'easeOutCirc'
	};
	
	//ScrollReveal().reveal('.global-header', srOptions);
	ScrollReveal()
		.reveal('.landing-page-intro', slideUp);
		ScrollReveal().reveal('.landing-page-intro .text-block', {delay: 1000, distance: "50px"});
	
	function homepageIntro() {

		var initial = "polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)";
		var show = "polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)";
		var hide = "polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)";

		anime({
			  targets: '.landing-page-intro__image',
			  webkitClipPath: [initial, show],
			  clipPath: [initial, show],
			  duration: 1000,
			  easing: 'easeOutCirc'
		});
	}
}

const animateInspireMePage = function (inspireMeImage) {
	
	var slideUp = {
		duration: 1000,
		opacity: 0.2,
		afterReveal: inspireMeImageClip,
		easing: 'easeOutCirc'
	};

	ScrollReveal().reveal(inspireMeImage, slideUp);
	
	const aspectRatioImage = inspireMeImage.querySelector(".aspect-ratio-image");
	
	function inspireMeImageClip() {

		var initial = "polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)";
		var show = "polygon(100% 0%, 0% 0%, 0% 100%, 100% 100%)";
		var hide = "polygon(100% 0%, 100% 0%, 100% 100%, 100% 100%)";

		anime({
			  targets: aspectRatioImage,
			  webkitClipPath: [initial, show],
			  clipPath: [initial, show],
			  duration: 2000,
			  easing: 'easeInOutCubic'
		});
	}
}

function inspireMePage () {
const inspireMeImage = document.querySelectorAll('.inspire-mess-image');

if (inspireMeImage.length > 0) {
	for (var i = 0; i < inspireMeImage.length; i++) {
		
		const loopedinspireMeImage = inspireMeImage[i];

		animateInspireMePage(loopedinspireMeImage);	
	}
}		
}


export default inspireMePage;
